import {useState} from "react"
import Button from "../../common/components/Button.jsx"
import Textfield from "../../common/components/Textfiled.jsx"
import {useGetDataVehicleInspectionQuery} from "./hooks/useGetDataVehicleInspectionQuery.js"

function ExcelVehiclesInspection(){
const [filters, setFilters] = useState({
    initialDate: "",
    finalDate: "",
    groupQuestion: "",
    warning: "",
    placa: "",
  })
  const {exportVehiclesInspected} = useGetDataVehicleInspectionQuery()

  const handleChangeFilters = ({name, value}) => {
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  return (
    <main>
      <header>
        <h1>Excel inspección de vehículos</h1>
      </header>
      <section className="d-flex flex-column justify-content-center align-items-center w-50 mx-auto">
        <div className="d-flex justify-content-around gap-3">
          <Textfield label="Fecha inicial" type="date" name="initialDate" value={filters.initialDate} onChange={handleChangeFilters} />
          <Textfield label="Fecha final" type="date" name="finalDate" value={filters.finalDate} onChange={handleChangeFilters} />
          {/* <Textfield label="Grupo de preguntas" name="groupQuestion" value={filters.groupQuestion} onChange={handleChangeFilters} /> */}
          {/* <Textfield label="Advertencia" name="warning" value={filters.warning} onChange={handleChangeFilters} /> */}
          {/* <Textfield label="Placa" name="placa" value={filters.placa} onChange={handleChangeFilters} /> */}
        </div>

        <Button onClick={() => exportVehiclesInspected({filters})}>Exportar excel</Button>
      </section>
    </main>
  )
}

export default ExcelVehiclesInspection;
